require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/es6/parse-float.js
// module id = ../../../../core-js/es6/parse-float.js
// module chunks = 13